export type CreditCardsConsentErrorCause =
  | "cancelled"
  | "network_fail"
  | "unknown";

export class CreditCardsConsentError extends Error {
  public cause: CreditCardsConsentErrorCause;

  constructor(message: string, cause: CreditCardsConsentErrorCause) {
    super(message);
    this.name = "CreditCardsConsentError";
    this.cause = cause;
  }
}
